import { useState, useContext } from 'react';
import { DealerPagesEventType } from 'lib/EventSchema';
import TrackingDataContext from 'contexts/TrackingDataContext';
import { trackDealerPagesClick } from 'lib/Tracking/DealerPages';
import ToggleExpandedButton from '../../ToggleExpandedButton';

// The max number of characters of the description we should show intiially.
export const CONTENT_LIMIT_CHAR_THRESHOLD = 350;

export default function Description({ content }: { content: string }): JSX.Element | null {
  const [isExpanded, setIsExpanded] = useState(false);
  const { dealerPageUrl } = useContext(TrackingDataContext);

  if (!content) {
    return null;
  }

  const canExpand = content.length > CONTENT_LIMIT_CHAR_THRESHOLD;

  return (
    <div className="description-container">
      <div className={`content${isExpanded ? ' expanded' : ''}`}>{content}</div>
      {canExpand && (
        <ToggleExpandedButton
          onClick={(): void => {
            setIsExpanded(!isExpanded);
            trackDealerPagesClick({
              type: DealerPagesEventType.read_more_about_click,
              dealerPageUrl,
            });
          }}
          isExpanded={isExpanded}
        />
      )}
      <style jsx>{`
        .description-container {
          display: flex;
          flex-direction: column;
        }

        .content {
          font-weight: 300;
          overflow-y: hidden;
          height: 70px;
          margin-bottom: 5px;
        }

        .content.expanded {
          overflow-y: initial;
          height: initial;
        }
      `}</style>
    </div>
  );
}
